import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { Button, SettingsCard } from "top-component-library";
import { MovedCardBody } from "../styles";

const MovedSettingsCard = ({ title, message, linkText, url }) => {
  const history = useHistory();

  return (
    <SettingsCard title={title}>
      <MovedCardBody>
        <p>{message}</p>
        <Button onClick={() => history.push(url)}>{linkText}</Button>
      </MovedCardBody>
    </SettingsCard>
  );
};

MovedSettingsCard.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default MovedSettingsCard;
